<template>
  <div class="slider-container">
    <div class="sliderArrows" :class="{ disabled: firstArrow }" @click="previousImage()">&lt;</div>
    <div class="img-container">
      <ImgSliderItem :url="currentImageUrl" />
    </div>
    <div class="sliderArrows" :class="{ disabled: secondArrow }" @click="nextImage()">></div>
  </div>
  <div class="counter">{{ currentImageIndex + 1 }} / {{ images.length }}</div>
</template>

<script lang="ts" setup>
import { computed, ref, toRefs } from 'vue'
import ImgSliderItem, { ImageProps } from '@/components/general/slider/ImgSliderItem.vue'
export interface ImageSliderProps {
  images: ImageProps[]
}

const props = defineProps<ImageSliderProps>()
const { images } = toRefs(props)
const currentImageUrl = ref<string>(images?.value[0]?.url ? images.value[0].url : '')
const firstArrow = computed(() => {
  return currentImageIndex.value === 0
})

const secondArrow = computed(() => {
  return currentImageIndex.value === images.value.length - 1
})

const currentImageIndex = ref(0)

const nextImage = () => {
  if (currentImageIndex.value >= images.value.length - 1) return
  currentImageIndex.value += 1
  currentImageUrl.value = images.value[currentImageIndex.value].url
}
const previousImage = () => {
  if (currentImageIndex.value === 0) return
  currentImageIndex.value -= 1
  currentImageUrl.value = images.value[currentImageIndex.value].url
}
</script>

<style scoped lang="scss">
.sliderArrows {
  cursor: pointer;
  font-weight: bold;
  font-size: 20px;
  background: #efefef;
  border-radius: 4px;
  padding: 10px;
  margin: 10px;
}
.sliderArrows.disabled {
  cursor: auto;
  visibility: hidden;
}

.slider-container {
  display: flex;
  flex-flow: row;
  align-items: center;
  justify-content: center;
}
.counter {
  text-align: center;
}
.img-container {
  height: 250px;
}
</style>
